import { EmailBox } from '@apply/components';
import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface EmailFieldProps {
    readOnly?: boolean;
    showWarning?: boolean;
}

export const EmailField: React.FC<EmailFieldProps> = ({ readOnly = false, showWarning = true }) => {
    const value = useBrokerDetailsStore((s) => s.email);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const brokerId = useBrokerDetailsStore((s) => s.brokerId);
    const changed = useBrokerFieldFieldChanged(FormField.Email);
    return (
        <>
            <EmailBox
                id='cEmail'
                value={value}
                onChange={(v) => updateFields({ email: v })}
                label='Email Address (also used as Login for the account)'
                width={'100%'}
                required={true}
                readOnly={readOnly}
            >
                <ShowIf showIf={brokerId > 0 && showWarning}>
                    <div className='warning'>* Changing this will also change the login for the account!</div>
                </ShowIf>
            </EmailBox>
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon={'asterisk'}
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
